import { useLocation } from "react-router-dom";
import { getOnboardingStep, ONBOARDING_TOTAL_STEPS } from "@/constants/onboardingSteps";
import { cn } from "@/utils/cn";

const SEGMENT_WIDTH = 77;

/**
 * Renders the "Step X of Y - Label" line and progress bar for the employer registration flow.
 * Renders nothing when the current route is not part of the flow (safe to mount anywhere).
 */
export function OnboardingStepIndicator() {
    const location = useLocation();
    const stepInfo = getOnboardingStep(location.pathname);

    if (!stepInfo) return null;

    const { step, total, label } = stepInfo;
    const stepLabel =
        step < total ? `Step ${step} of ${total} - ${label}` : `Step ${step} of ${total}`;

    return (
        <div className="mb-8" role="progressbar" aria-valuenow={step} aria-valuemin={1} aria-valuemax={total} aria-label={stepLabel}>
            <p className="font-clash-display font-medium text-base text-medium-dark-grey tracking-[-0.08px]">
                {stepLabel}
            </p>
            <div className="flex items-center gap-[20px] mt-2" aria-hidden>
                {Array.from({ length: ONBOARDING_TOTAL_STEPS }, (_, i) => {
                    const isFilled = i + 1 <= step;
                    return (
                        <div
                            key={i}
                            className={cn("h-[3px] rounded-[13px] border shrink-0 transition-colors duration-200",
                                isFilled ? "border-transparent" : "border-[#adada7]"
                            )}
                            style={{
                                width: SEGMENT_WIDTH,
                                backgroundColor: isFilled ? "var(--color-primary-button)" : "var(--color-off-white)",
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
}
